import React from 'react';
import { CustomButton } from '../../../shared/components/CustomButton';

export const ConfirmationPage: React.FC = () => (
    <div className='py-4'>
        <h4 className="text-grey-body xl:max-w-[50%]">
            Keep an eye out on your inbox, we look forward to seeing you!
        </h4>
        <CustomButton
            text={'Back to home'}
            className={'mt-[1.72rem]'}
            link={'/'}
            newWindow={false}
        />
    </div>
);